import * as React from "react";
import { useContext } from "react";
import MainAppBar from "./main-appbar";
import Footer from "./footer";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { Box, Container, CssBaseline } from "@mui/material";
import { LayoutContext } from "../contexts/layout-context";

export default function Layout() {
  const { fullscreen } = useContext(LayoutContext);
  if (fullscreen) return <Outlet/>;
  return (
    <Box>
      <MainAppBar/>
      <Box
        component="main"
        sx={{
          mt: {
            xs: "56px",
            sm: "64px",
          },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Container maxWidth="lg" sx={{
          py: 4, minHeight: {
            xs: "calc(100vh - 56px - 60px)",
            sm: "calc(100vh - 64px - 60px)"
          }
        }}>
          <Outlet/>
        </Container>
        <Footer/>
      </Box>
      <ScrollRestoration/>
    </Box>
  );
}
